import { type Ref, ref, onMounted, onUnmounted, watch } from 'vue';
import {
  useWindowScroll,
  useElementBounding,
  watchDebounced,
  useCssVar,
  watchOnce,
} from '@vueuse/core';

export function useSticky(refElement: Ref<any>, placeholderRefElement: Ref<HTMLElement>) {
  const isSticky = ref(false);
  const { y } = useWindowScroll();
  const bounds = useElementBounding(refElement);
  const headerHeight = useCssVar('--header-height');
  const originalHeight = ref(0);
  const originalDistance = ref(0);

  watchOnce(bounds.height, () => {
    originalHeight.value = bounds.height.value;
  });
  watchOnce(bounds.top, () => {
    originalDistance.value = bounds.top.value;
  });

  const scrollDistance = computed(() => originalDistance.value);

  watchDebounced(
    y,
    (newY) => {
      if (newY > scrollDistance.value) {
        refElement.value?.classList?.add('fixed');
        refElement.value?.classList?.add('top-0');
        refElement.value?.classList?.add('left-0');
        refElement.value?.classList?.add('w-full');
        if (
          placeholderRefElement &&
          placeholderRefElement.value &&
          placeholderRefElement.value.style
        ) {
          placeholderRefElement.value.style.height = `${originalHeight.value}px`;
        }
        isSticky.value = true;
      } else {
        refElement.value?.classList?.remove('fixed');
        refElement.value?.classList?.remove('top-0');
        refElement.value?.classList?.remove('left-0');
        refElement.value?.classList?.remove('w-full');
        if (
          placeholderRefElement &&
          placeholderRefElement.value &&
          placeholderRefElement.value.style
        ) {
          placeholderRefElement.value.style.height = `0px`;
        }
        isSticky.value = false;
      }
    },
    {
      debounce: 10,
    }
  );

  return {
    originalHeight,
    originalDistance,
    bounds,
    isSticky,
    y,
  };
}
